import { Navigate, useParams } from "react-router-dom";
import Mission1 from "@/modules/premiere-video/missions/Mission1";
import Mission2 from "@/modules/premiere-video/missions/Mission2";
import Mission3 from "@/modules/premiere-video/missions/Mission3";
import Mission4 from "@/modules/premiere-video/missions/Mission4";
import Mission5 from "@/modules/premiere-video/missions/Mission5";
import Mission6 from "@/modules/premiere-video/missions/Mission6";
import Mission7 from "@/modules/premiere-video/missions/Mission7";

const MAP = { 1: Mission1, 2: Mission2, 3: Mission3, 4: Mission4, 5: Mission5, 6: Mission6, 7: Mission7 };

export default function MissionPage() {
  const { id } = useParams();
  const C = MAP[id];
  if (!C) return <Navigate to="/parcours" replace />;
  return <C key={id} />;
}
